<template>
  <div class="hello">
    <header>
      <h1>Sweet定位-隐私政策</h1>
      <p>最近更新日期：2026年04月27日</p>
    </header>
    <section>
      <h2>重要提示</h2>
      <p>欢迎您使用Sweet定位移动应用软件及相关产品和服务（以下简称“本应用”）。我们深知个人信息对您的重要性，因此我们将严格依照《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》、《信息安全技术 个人信息安全规范》等法律法规，保护您的个人信息安全与合法权益。本隐私政策旨在向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您对个人信息享有的权利。</p>
      <p>本隐私政策属于《Sweet定位-用户协议》的组成部分。您在使用本应用前，请仔细阅读并理解本政策。一旦您使用或继续使用本应用，即表示您同意我们按照本政策处理您的个人信息。</p>
      <h2>一、适用范围</h2>
      <p>1.1 本隐私政策适用于由重庆盛纳科技有限公司（以下简称“我们”或“公司”）提供的Sweet定位应用及其相关服务，包括但不限于定位共享、30天足迹回顾，即时聊天、动态提醒等功能。</p>
      <p>1.2 本政策不适用于第三方通过本应用提供的服务，第三方服务将适用其独立的隐私政策，我们不对第三方的隐私保护行为承担责任。</p>
      <h2>二、信息收集与使用</h2>
      <p>我们收集您的信息主要是为了您和您的情侣能够更便捷、安全地使用本应用的各项功能和服务。我们将根据合法、正当、必要的原则收集信息，您提供的信息将用于保障产品基础运行、实现功能服务、优化产品体验、保障使用安全及遵循法律法规要求。</p>
      <p>2.1必要信息收集：</p>
      <ul>
        <li>(1)保障应用基础运行信息：当您使用Sweet定位及相关服务时，为保障软件与服务的正常运行，我们会收集您的移动设备硬件型号、操作系统版本号、设备识别码、设备型号、唯一设备标识符信息、网络设备硬件地址（MAC 地址）、IP 地址、软件版本号、网络接入方式及类型、操作日志、设备存储读写权限、地理位置、传感器<b style="color: red;">（当您使用定位及相关服务时，我们需要使用加速度传感器，传感器信息不会存储于我们的服务器中）</b>等信息。这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。</li>
        <li>(2)注册、认证、登录信息：您注册、登录本应用时，通过手机号创建账号，我们将通过发送短信验证码来验证您的身份是否有效，应用收集您的手机号码、密码等信息是为了帮助您完成注册。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若您不提供这类信息，可能无法正常使用我们的服务。您也可以使用第三方账号（QQ、微信、苹果账号）登录本应用，此时您将授权我们获取您在第三方平台注册的公开信息（头像、昵称等），并将您的第三方账号与您的“Sweet定位”账户绑定。</li>
        <li>(3)定位信息：为实现情侣定位共享功能，当您开启定位权限后，我们会收集您的实时地理位置信息（包括经纬度、定位时间）。该信息仅在您与情侣双方授权共享的范围内使用，用于在应用内展示彼此位置。您可随时通过设备系统设置或应用内权限设置关闭定位权限，但关闭后将无法使用定位共享功能。当您使用定位共享功能时，我们会在后台持续收集您的位置信息，这是定位功能正常运行所必须的。</li>
      </ul>
      <p>2.2 非必要信息收集：您可根据自身需求选择填写昵称、头像等以完善您的个人信息，这些信息将用于账号展示，提升您的使用体验。</p>
      <p>2.3 在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>
      <ul>
        <li>(1)与国家安全、国防安全直接相关的；</li>
        <li>(2)与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>(4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
        <li>(5)所收集的您的个人信息是您自行向社会公众公开的；</li>
        <li>(6)从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
        <li>(6)法律法规规定的其他情形。</li>
      </ul>
      <h2>三、对 Cookie 和同类技术的使用</h2>
      <p>3.1 Cookie和同类技术是互联网中的通用常用技术。当您使用本应用及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本应用时的信息。</p>
      <p>3.2 我们使用Cookie和同类技术主要为了实现以下功能或服务：</p>
      <ul>
        <li>(1)保障产品与服务的安全、高效运转：设置认证与保障安全性的Cookie或匿名标识符，确认您是否安全登录服务，防范盗用、欺诈等不法行为，改进服务效率，提升登录和响应速度。</li>
        <li>(2)提升访问体验：如实现一键登录流程。</li>
      </ul>
      <p>3.3 我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。</p>
      <h2>四、信息存储</h2>
      <p>4.1 存储地点：我们依照法律法规的规定，将在运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。</p>
      <p>4.2 存储期限：我们仅在为提供本应用及服务之目的所必需的期间内保留您的个人信息，包括聊天记录、填写的个人信息、定位记录等，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除处理，但法律法规另有规定的除外。</p>
      <h2>五、信息共享、转让、公开披露</h2>
      <p>5.1 共享：我们不会与重庆盛纳科技有限公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
      <ul>
        <li>(1)在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
        <li>(2)我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
        <li>(3)与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
  </li>
        <li>目前，我们的授权合作伙伴包括以下几大类型：</li>
        <li>技术供应商、服务提供商和其他合作伙伴：为我们提供技术基础设施服务、分析服务使用方式、提供客户服务等支持。</li>
        <li>广告平台、数据分析服务类的授权合作伙伴：除非得到您的授权许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，且这些信息不会识别您个人。</li>
      </ul>
      <p>注意：对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
      <p>5.2 转让：我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <ul>
          <li>(1)在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
          <li>(2)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
        </ul>
      <p>5.3 公开纰漏：在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：</p>
      <ul>
          <li>(1)获得您明确同意后；</li>
          <li>(2)与国家安全、国防安全直接相关的；</li>
          <li>(3)与公共安全、公共卫生、重大公共利益直接相关的；</li>
          <li>(4)与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
          <li>(5)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您的同意的；</li>
          <li>(6)您自行向社会公众公开的个人信息；</li>
          <li>(7)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
        </ul>
        <h2>六、信息安全保障</h2>
        <p>6.1 我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</p>
        <p>6.2 我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</p>
        <p>6.3 我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</p>
        <p>6.4 互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。同时，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</p>
        <p>6.5 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
        <h2>七、用户权利</h2>
        <p>按照中国相关的法律、法规、标准，我们重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改、删除以及改变授权同意的权利，以使您有能力保障您的隐私和安全。</p>
        <p>7.1 访问、更正您的个人信息：当您完成本应用的账号注册、登录并进行合理和必要的身份验证后，您可以通过“个人中心->头像->个人信息”查阅、修改您提交的个人信息（包括头像、昵称等）。</p>
        <p>7.2 变更或撤回授权范围：您可以通过设备本身操作系统变更或撤回GPS地理位置、相册等权限，我们将根据您变更或撤回权限的设置进行个人信息的收集，如您撤回权限授权我们将不再收集与这些权限相关的信息，但这可能导致部分功能或全部功能的不可用。同时，您变更或撤回授权的决定，不会影响我们此前基于您的授权而进行的个人信息处理。</p>
        <p>7.3 注销您的账号：我们支持您随时注销此前注册的账户，您可以通过“个人中心->头像->个人信息->注销账号”自行操作注销，或通过应用内部的客服邮箱联系我们的工作人员申请注销。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定需要保留的除外。</p>
        <p>7.4 投诉举报：如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过电子邮件<b>sweet_9966@126.com</b>联系我们，我们核查后会在规定期限内反馈您的投诉与举报。</p>
        <p>7.5 访问隐私政策：您可以点击“个人中心->隐私政策”查看本隐私政策的全部内容。</p>
        <p>7.6 停止运营告知权利：若我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知通过电子邮件、信函、电话、推送通知、公告等形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>
        <h2>八、未成年人使用条款</h2>
        <p>我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是 18 周岁以下的未成年人，在使用Sweet定位服务前，应事先取得您的家长或法定监护人的书面同意。若您是未成年人的监护人，当您对所监护的未成年人的个人信息有相关疑问时，请通过本政策提供的联系方式与我们联系。</p>
        <h2>九、隐私政策的修订和通知</h2>
        <p>9.1 为给您提供更好的服务，本应用及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，该等修订构成本隐私政策的一部分并具有等同于本隐私政策的效力。但未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。</p>
        <p>9.2 本隐私政策更新后，我们会在本应用客户端发出更新版本，以便您及时了解最新的隐私政策。如您继续使用我们的服务，表示同意接受修订后的本政策的内容，如果更新的内容需要采集个人敏感信息，应用将会再次征求同意。</p>
        <p>9.3 重大变更（服务模式、所有权结构、信息共享对象、用户权利、责任部门等变化）会通过显著方式通知，说明具体变更内容。</p>
        <h2>十、其他</h2>
        <p>10.1 本政策标题仅为阅读方便，不影响条款含义或解释。</p>
        <p>10.2 相关词语释义：</p>
        <ul>
          <li>(1)个人信息：以电子或其他方式记录的识别特定自然人或反映其活动情况的各种信息。</li>
          <li>(2)个人敏感信息：泄露、非法提供或滥用可能危害人身财产安全，导致名誉、身心健康受损或歧视性待遇的信息。</li>
          <li>(3)去标识化：技术处理后不借助额外信息无法识别主体的过程。</li>
          <li>(4)匿名化：技术处理后无法识别主体且信息不能复原的过程。</li>
        </ul>
        <p>10.3 本政策版权归我们所有，在法律允许范围内拥有解释和修改权利。</p>
        <p>10.4 如有疑问，请通过邮件<b>sweet_9966@126.com</b>与我们进行沟通。</p>
        <h2>十一、第三方SDK接入信息</h2>
        <p>11.1 接入使用的第三方SDK：</p>
        <div>
          <table border="1" class="tab">
            <thead>
              <tr>
                <th>SDK 名称</th>
                <th>公司名称</th>
                <th>收集目的</th>
                <th>收集方式</th>
                <th>收集范围</th>
                <th>隐私政策</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ele, index) in commonInfo" >
                <td>{{ ele.name }}</td>
                <td>{{ ele.company }}</td>
                <td>{{ ele.goal }}</td>
                <td>{{ ele.type }}</td>
                <td>{{ ele.range }}</td>
                <td class="link">
                  <a :href="ele.link">{{ ele.link }}</a>
                </td>
              </tr>
              <tr v-if="!isIOS" v-for="(data, index) in isAndroidInfo">
                <td>{{ data.name }}</td>
                  <td>{{ data.company }}</td>
                  <td>{{ data.goal }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.range }}</td>
                  <td class="link">
                    <a :href="data.link">{{ data.link }}</a>
                  </td>
              </tr>
            </tbody>
          </table>
          <p>
              请注意，第三方 SDK
              可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，具体请以其公示的官方说明为准。
            </p>
        </div>
        <p>11.2 APP客户端程序获取权限后的用途：</p>
        <ul>
          <li>(1)获取本机电话号码：用于手机号码一键登录</li>
          <li>(2)后台持续定位：用于实时位置共享、获取网络类型和WIFI名称</li>
          <li>(3)音频录制：用于发送语音消息</li>
          <li>(4)相机和访问照片：用于聊天会话的拍照和照片分享</li>
        </ul>
        <p>本应用会检测网络连接状态和手机电量，以优化用户体验和节省流量，但不会收集或传输个人隐私信息。</p>
        <p v-if="!isIOS">11.3 Android客户端自启动和关联启动行为说明：</p>
        <ul v-if="!isIOS">
          <li>(1)为确保本应用程序能稳定为您提供“实时位置共享”的功能服务，我们会使用Android系统的自启动或关联启动权限。</li>
          <li>(2)在您初次注册Sweet定位并开启“实时位置共享”功能时，Sweet定位会明确征得您的同意，由您主动在应用程序管理中开启此权限，如您未授权则不会有自启动行为。</li>
          <li>(3)获得授权后本应用如因手机重启或内存清理等停止运行时，会通过一定频率监听Android系统发送广播，以自行恢复“实时位置共享”后台程序。</li>
        </ul>
    </section>
  </div>
</template>

<script>
let u = navigator.userAgent
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //安卓
let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
export default {
  name: 'HelloWorld',
  data () {
    return {
      isIOS:isIOS,
      commonInfo: [
        {
          name: "极光推送 - JPush SDK",
          company: "深圳市和讯华谷信息技术有限公司",
          goal: "为 APP 用户提供信息推送服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID、Boot ID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、DHCP、WIFI状态信息）、推送信息日志：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识，保证服务在不同设备上的兼容性和准确识别，同时了解推送信息送达的情况。设备标识符（包括IMEI、MAC、IMSI）：可选个人信息，用于推送服务基本业务功能场景中生成终端用户设备唯一标识的补充，提升唯一设备标识的准确性，进而提升推送的精确度和触达率；网络信息（包括SSID、BSSID、WIFI列表信息、基站信息、SIM卡状态）：可选个人信息，用于推送服务基本业务功能场景中判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。位置相关信息：地理围栏、用户分群推送、用户洞察扩展功能所必要个人信息，用于提供线下场景的精细化推送，根据位置信息推荐更符合您需要的推送内容；软件列表信息（包括软件列表及软件运行列表信息）：用户分群、应用自启动、链路调节器、用户洞察扩展功能所必要个人信息：有助于帮助您洞察您终端用户的兴趣偏好，帮助您为用户提供更合适的推送内容，同时优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。",
          link: "https://www.jiguang.cn/license/privacy",
        },
       {
          name: "友盟+移动统计SDK",
          company: "友盟同欣（北京）科技有限公司",
          goal: "进行APP数据统计分析",
          type: "调用系统相关接口自动采集",
          range:"设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID ; 可选-IMEI/IMSI/ICCID）、 网络信息、位置信息（可选）、应用列表（可选）",
          link:"https://www.umeng.com/page/policy"
        }, 
        {
          name: "友盟+社会化分享SDK",
          company: "友盟同欣（北京）科技有限公司",
          goal: "提供APP信息分享服务",
          type: "调用系统相关接口自动采集",
          range: "设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、应用列表（可选）",
          link: "https://www.umeng.com/page/policy"
        },
        {
          name: "微信Open SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "微信账号登录、微信支付、微信分享",
          type: "调用系统相关接口自动采集",
          range: "分享的图片和内容、主动选择的微信头像和昵称、微信支付订单标识",
          link: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8#__section1"
        },
        {
          name: "QQ互联SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "QQ账号登录、QQ分享",
          type: "调用系统相关接口自动采集",
          range: "分享的图片和内容、主动选择的QQ头像和昵称",
          link: "https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
        },
         {
          name: "高德地图、定位SDK",
          company: "高德软件有限公司",
          goal: "用于提供定位和地图功能",
          type: "调用系统相关接口自动采集",
          range: "应用名和版本号、设备品牌型号、操作系统、运营商基站和信号信息、传感器信息、IP地址、设备网络硬件地址（MAC）、蓝牙信息、WiFi状态和SSID和附近WiFi列表、电话信息、定位经纬度（含后台定位）、标识符OAID、GAID",
          link: "https://lbs.amap.com/home/privacy/"
        }
      ],
      isAndroidInfo:[
         {
          name: "Bugly SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "排查质量问题,帮助APP提升运行质量",
          type: "调用系统相关接口自动采集",
          range: "手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID",
          link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
        },
        {
          name: "支付宝支付客户端SDK",
          company: "支付宝(杭州)信息技术有限公司",
          goal: "开通付费会员的支付",
          type: "调用系统相关接口自动采集",
          range: "设备状态权限、网络连接权限",
          link: "https://opendocs.alipay.com/isv/03l221"
        },
        {
          name: "华为推送SDK",
          company: "华为软件技术有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "应用信息（应用基本信息），设备信息（AAID、设备标识符、设备硬件信息、系统基本信息、系统设置）",
          link: "https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177"
        },
        {
          name: "小米推送SDK",
          company: "北京小米移动软件有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型、WiFi状态",
          link: "https://dev.mi.com/console/doc/detail?pId=1822"
        },
        {
          name: "vivo PUSH - SDK消息推送",
          company: "维沃移动通信有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android ID）、使用推送服务的应用软件信息（如应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络相关信息（如IP地址、网络类型）、国家码、设备类型；推送SDK版本号、设备型号、操作系统版本、当前网络类型、消息发送结果、通知栏状态（如通知栏权限、用户点击行为）、锁屏状态（如是否锁屏，是否允许锁屏通知）",
          link: "https://dev.vivo.com.cn/documentCenter/doc/652#"
        },
        {
          name: "OPPO PUSH客户端SDK",
          company: "广东欢太科技有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "RegisterId、appKey、MCS应用包名、版本号、推送SDK版本号",
          link: "https://open.oppomobile.com/new/developmentDoc/info?id=11228"
        },
        {
          name: "荣耀推送SDK",
          company: "深圳荣耀软件技术有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备标识符（AAID、PushToken）、APPID、应用包名",
          link: "https://developer.honor.com/cn/docs/11002/guides/sdk-data-security"
        },
        {
          name: "移动智能终端补充设备标识体系统一调用 SDK",
          company: "中国信息通信研究院",
          goal: "生成设备唯一标识符",
          type: "调用系统相关接口自动采集",
          range: "设备制造商、设备型号、设备品牌、设备网络运营商名称、App 包名及签名信息，或在对应应用商店的 APPID、开放匿名设备标识符(OAID)、开发者匿名设备标识符(VAID)、应用匿名设备标识符(AAID)",
          link: "https://www.msa-alliance.cn/col.jsp?id=122"
        },
        {
          name: "360加固SDK",
          company: "北京鸿享技术服务有限公司",
          goal: "用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（Android ID、OAID）",
          link: "https://jiagu.360.cn/#/global/help/322",
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}
.hello{
  margin:20px;
}
section{
  padding-bottom:20px;
}
h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue